// extracted by mini-css-extract-plugin
export default {"root":"ThemeEditor_root__iSI-6","tabRoot":"ThemeEditor_tabRoot__+xyGi","iconContainer":"ThemeEditor_iconContainer__4xxjK","iconUploader":"ThemeEditor_iconUploader__2vJuu"};